export const SESSION_EXPIRED_EVENT = "portal:session-expired";
export const SESSION_ACTIVITY_EVENT = "portal:session-activity";
export const AUTHENTICATED_SESSION_KEY = "jstarter.authenticated-session";
